export default {"src":"/_next/static/media/0x29b0da86e484e1c0029b56e817912d778ac0ec69.f75ac279.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};